import { render, staticRenderFns } from "./OnlineReserve.vue?vue&type=template&id=b5cca4ba&scoped=true"
import script from "./OnlineReserve.vue?vue&type=script&lang=js"
export * from "./OnlineReserve.vue?vue&type=script&lang=js"
import style0 from "./OnlineReserve.vue?vue&type=style&index=0&id=b5cca4ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cca4ba",
  null
  
)

export default component.exports